import React, { useEffect } from 'react';
import { images } from '../../../Constants/ImageUrls';
import { isWhiteColor } from '../../../Utils/helper';
import AnywhereHorizontalScroll from '../../HelperComponents/AnywhereHorizontalScroll';
import { GridWrapper } from '../BannersGrid/styled';
import { cardServedEvent } from '../../../Utils/StoreHomePageUtils';
import WaveCarouselCard from './WaveCarouselCard';
import { RelativeDiv, SectionTitle } from './WaveCarousel.styled';

export default function WaveGridCarousel(props) {
  const { banner, type, parentIndex } = props;

  useEffect(() => {
    // window?.instgrm?.Embeds.process();
    // let copy_data = JSON.parse(JSON.stringify(banner));
    // if (getWebUserType() === "B" && banner.headingAlignment === "WAVE") {
    //     copy_data.items[0].itemType = "insta_video";
    // }
    cardServedEvent(banner);
  }, []);
  return (
    <GridWrapper
      sectionBgColorEnd={banner?.sectionBgColorEnd}
      sectionBgColorStart={banner?.sectionBgColorStart}
      padding={
        !isWhiteColor(banner?.sectionBgColorStart, banner?.sectionBgColorEnd)
      }
    >
      {banner?.heading && type != 'bestSeller' ? (
        <SectionTitle>
          <h2>{banner?.heading} </h2>
        </SectionTitle>
      ) : null}
      <RelativeDiv>
        <AnywhereHorizontalScroll
          firstElementId={`${banner?.itemName}first`}
          lastElementId={`${banner?.itemName}last`}
          leftArrow={<img src={images.arrowdownforward} alt="arrow Forward" />}
          rightArrow={<img src={images.arrowdownforward} alt="arrow Forward" />}
          scrolledWidth={420}
        >
          {banner?.items?.map((element, index) => {
            return (
              <WaveCarouselCard
                parentIndex={parentIndex}
                sectionHeading={banner?.heading}
                sectionName={banner?.itemName}
                banner={banner}
                type={type}
                element={element}
                key={index}
                index={index}
                length={banner?.items?.length}
              />
            );
          })}
        </AnywhereHorizontalScroll>
      </RelativeDiv>
    </GridWrapper>
  );
}
